import { render, staticRenderFns } from "./logwood-package-input.vue?vue&type=template&id=5821f1a5&scoped=true&"
import script from "./logwood-package-input.vue?vue&type=script&lang=ts&"
export * from "./logwood-package-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821f1a5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5821f1a5')) {
      api.createRecord('5821f1a5', component.options)
    } else {
      api.reload('5821f1a5', component.options)
    }
    module.hot.accept("./logwood-package-input.vue?vue&type=template&id=5821f1a5&scoped=true&", function () {
      api.rerender('5821f1a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/components/logwood-package-input.vue"
export default component.exports